import { FormData } from './ShoptetRegistrationForm';
import { AbstractFormBloc } from 'src/library/bloc/AbstractFormBloc';
import { ServiceProvider } from 'src/services/ServiceProvider';
import { NotFoundError } from 'src/errors';

declare const SERVICES: ServiceProvider;

export class ShoptetRegistrationBloc extends AbstractFormBloc<any, FormData> {
    getName(): string {
        return 'ShoptetRegistrationBloc';
    }
    getFormData(data: any): FormData {
        return {
            url: data?.url ?? '',
        };
    }
    requestGetData(): Promise<any> {
        return Promise.resolve();
    }
    requestSetData(data: FormData): Promise<any> {
        return SERVICES.auth.shoptetLogin(data.url);
    }

    responseSetData(authUrl: string) {
        window.location.href = authUrl;
    }

    getErrorMessage(error: Error) {
        if (error instanceof NotFoundError) {
            return this.t('error.shopNotFound');
        }
        return super.getError(error);
    }
}
